import React from 'react';

const TableComponent = ({ data }) => {
  return (
    <div>
      <table  id="FaqsNewid" className='Top5Header' style={{width:"100%"}}>
        <thead>
          <tr>
            <th>Group</th>
            <th>Report Name</th>
            <th style={{textAlign:"center"}}>Views</th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(data).map((category, index) => (
            <tr key={index}>
              <td>{data[category].name}</td>
              <td>
                <ul>
                  {data[category].chats[0].XAxis.map((xValue, i) => (
                    <li key={i}>{xValue},</li>
                  ))}
                </ul>
              </td>
              <td style={{textAlign:"center"}}>
                <ul>
                  {data[category].chats[0].YAxis.map((yValue, i) => (
                    <li key={i}>{yValue === 0 ? 'No View': yValue}</li>
                  ))}
                </ul>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableComponent;
